export default "__VITE_ASSET__CYqFfW2i__"